import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

/** Gates the internal Staffing Sales Discovery meeting type. */
export function useStaffingDiscoveryMeetingTypeEnabled(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.meeting_copilot_staffing_discovery)
  );
}
